export default __webpack_public_path__ + "static/broderie5.inspirations-ce54344a3f4996cc13d6d8b6dd03eebb.jpg";